/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_iupac_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`They are single-letter codes that represent a set of nucleotides, such as R for purines (A/G), Y for pyrimidines (C/T) and N for any base. They are used to describe degenerate primers and motifs.`)
};

const es_iupac_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Son códigos de una letra que representan un conjunto de nucleótidos, como R para purinas (A/G), Y para pirimidinas (C/T) y N para cualquier base. Se usan para describir cebadores y motivos degenerados.`)
};

const de_iupac_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es sind einzelne Buchstabencodes, die eine Menge von Nukleotiden darstellen, wie R für Purine (A/G), Y für Pyrimidine (C/T) und N für jede Base. Sie werden verwendet, um degenerierte Primer und Motive zu beschreiben.`)
};

const nl_iupac_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Het zijn eenlettercodes die een reeks nucleotiden vertegenwoordigen, zoals R voor purines (A/G), Y voor pyrimidines (C/T) en N voor elke base. Ze worden gebruikt om degeneratieve primers en motieven te beschrijven.`)
};

const fr_iupac_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ce sont des codes à une lettre qui représentent un ensemble de nucléotides, comme R pour les purines (A/G), Y pour les pyrimidines (C/T) et N pour n'importe quelle base. Ils servent à décrire des amorces et motifs dégénérés.`)
};

const it_iupac_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sono codici a una lettera che rappresentano un insieme di nucleotidi, come R per le purine (A/G), Y per le pirimidine (C/T) e N per qualsiasi base. Vengono usati per descrivere primer e motivi degenerati.`)
};

const pt_br2_iupac_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`São códigos de uma única letra que representam um conjunto de nucleotídeos, como R para purinas (A/G), Y para pirimidinas (C/T) e N para qualquer base. São usados para descrever primers e motivos degenerados.`)
};

const pt_iupac_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`São códigos de uma letra que representam um conjunto de nucleótidos, como R para purinas (A/G), Y para pirimidinas (C/T) e N para qualquer base. São usados para descrever primers e motivos degenerados.`)
};

const ja_iupac_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ヌクレオチドの集合を表す1文字のコードで、例えばRはプリン (A/G)、Yはピリミジン (C/T)、Nは任意の塩基を表します。縮重プライマーやモチーフの記述に使われます。`)
};

const zh_iupac_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`它们是代表一组核苷酸的单字母代码，例如 R 表示嘌呤（A/G），Y 表示嘧啶（C/T），N 表示任意碱基。它们用于描述简并引物和模体。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const iupac_faq_a1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.iupac_faq_a1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("iupac_faq_a1", locale)
	if (locale === "en") return en_iupac_faq_a1(inputs)
	if (locale === "es") return es_iupac_faq_a1(inputs)
	if (locale === "de") return de_iupac_faq_a1(inputs)
	if (locale === "nl") return nl_iupac_faq_a1(inputs)
	if (locale === "fr") return fr_iupac_faq_a1(inputs)
	if (locale === "it") return it_iupac_faq_a1(inputs)
	if (locale === "pt-BR") return pt_br2_iupac_faq_a1(inputs)
	if (locale === "pt") return pt_iupac_faq_a1(inputs)
	if (locale === "ja") return ja_iupac_faq_a1(inputs)
	return zh_iupac_faq_a1(inputs)
};